import request from '@aned/request';

export async function optSelect(params) {
  return request('/api/route/opt/selectPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

export async function selectWarehouseInfoPage(params) {
  return request('/api/route/opt/selectWarehouseInfoPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

// 查询导出
export async function exportOpt(params) {
  return request('/api/route/opt/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}

// 留仓导出
export async function exportOptLeave(params) {
  return request('/api/route/opt/selectWarehouseInfoExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'basic',
  });
}
